import { AutoAwesome, Code, ManageAccounts, MoreVert, PlayCircleFilled, Search } from "@mui/icons-material";
import { Box, IconButton, ListItemIcon, Menu, MenuItem, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { permissionTest } from "system/InfegyUser";

export interface QuickSearchActionsProps {
  editorContent: string;
  selectedDashboardOption: any;
  isUsingAIForm: boolean;
  setOverrideAIForm: (override: boolean) => void;
  onSubmit: () => void;
}


export default function QuickSearchActions(props: QuickSearchActionsProps): JSX.Element {
  const { i18n } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();

  const {editorContent, selectedDashboardOption, isUsingAIForm, setOverrideAIForm, onSubmit} = props;

  const [optionsMenuAnchorEl, setOptionsMenuAnchorEl] = React.useState<null | HTMLElement>(null);

  const canSubmit = editorContent.trim().length > 0 && selectedDashboardOption !== undefined;

  return (
    <Box>
      <IconButton
        sx={{ color: theme.palette.text.secondary, p: 0, ml: 0, mr: 0, opacity: 0.7, "&:hover": { opacity: 1, color: theme.palette.primary.main } }}
        onClick={(event: React.MouseEvent<HTMLElement>): void => {
          setOptionsMenuAnchorEl(event?.currentTarget);
        }} >
        <MoreVert sx={{ fontSize: "2rem" }} />
      </IconButton>
      <IconButton
        sx={{ color: canSubmit ? theme.palette.primary.main : theme.palette.text.secondary, p: 0, ml: 0, mr: 1, opacity: canSubmit ? 1 : 0.3 }}
        disabled={!canSubmit}
        onClick={(event: any): void => {
          onSubmit();
        }} >
        <PlayCircleFilled sx={{ fontSize: "2.5rem" }} />
      </IconButton>
      <Menu
        anchorEl={optionsMenuAnchorEl}
        open={!!optionsMenuAnchorEl}
        onClose={() => setOptionsMenuAnchorEl(null)} >
        {/* <MenuItem onClick={() => navigate("/me")}>
          <ListItemIcon>
            <ManageAccounts fontSize="small" />
          </ListItemIcon>
          {i18n.t("homepages.edit-default-homepage")}
        </MenuItem> */}
        <MenuItem onClick={() => {
          sessionStorage.setItem("skipQuickSearchRedirect", "true");
          navigate("/start");
        }}>
          <ListItemIcon>
            <Search fontSize="small" />
          </ListItemIcon>
          {i18n.t("advanced-search")}
        </MenuItem>
        {permissionTest("ai_features") && (<>
          {!!isUsingAIForm && (
            <MenuItem onClick={() => setOverrideAIForm(true)}>
              <ListItemIcon>
                <Code fontSize="small" />
              </ListItemIcon>
              {i18n.t("homepages.use-boolean-search")}
            </MenuItem>
          )}
          {!isUsingAIForm && (
            <MenuItem onClick={() => setOverrideAIForm(false)}>
              <ListItemIcon>
                <AutoAwesome fontSize="small" />
              </ListItemIcon>
              {i18n.t("homepages.use-ai-query-assist")}
            </MenuItem>
          )}
        </>)}
      </Menu>
    </Box>
  );
}